import { configureStore } from '@reduxjs/toolkit';
import profileReducer from './slices/profileSlice';
import learndleWordReducer from './slices/learndleWordSlice';
import authReducer from './slices/authSlice';
import childProfileReducer from './slices/childProfileSlice';
import levelReducer from './slices/levelSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    learndleWord: learndleWordReducer,
    childProfile: childProfileReducer,
    level: levelReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store;
